/**
 * @fileoverview Legal microcopy adjacent to storefront purchase CTAs.
 * @description Links to Terms, Returns, and Shipping policies within one click
 * of Buy buttons — required for Merchant Center policy discoverability near
 * the purchase action, not only in the site footer.
 * @module ads-framework/PurchaseLegalMicrocopy
 */

import Link from "next/link"
import { siteConfig } from "~/lib/config/site"

/**
 * Props for purchase-adjacent legal links.
 *
 * @interface PurchaseLegalMicrocopyProps
 * @property {string} [className] - Optional wrapper classes.
 */
interface PurchaseLegalMicrocopyProps {
  className?: string
}

/**
 * Compact legal links shown below Buy CTAs on framework and checkout surfaces.
 *
 * @param {PurchaseLegalMicrocopyProps} props - Component properties.
 * @returns {JSX.Element} Legal microcopy with policy links.
 */
export function PurchaseLegalMicrocopy({ className = "" }: PurchaseLegalMicrocopyProps): JSX.Element {
  return (
    <p className={`text-center text-xs text-muted-foreground ${className}`.trim()}>
      By purchasing you agree to our{" "}
      <Link href={siteConfig.baseLinks.terms} className="underline-offset-4 hover:underline">
        Terms
      </Link>
      ,{" "}
      <Link href={siteConfig.baseLinks.license} className="underline-offset-4 hover:underline">
        Software License
      </Link>
      ,{" "}
      <Link href={siteConfig.baseLinks.returns} className="underline-offset-4 hover:underline">
        Return Policy
      </Link>
      , and{" "}
      <Link href={siteConfig.baseLinks.shipping} className="underline-offset-4 hover:underline">
        Shipping Policy
      </Link>
      .
    </p>
  )
}
